import { render } from "./Argument3.vue?vue&type=template&id=639a31aa"
import script from "./Argument3.vue?vue&type=script&lang=js"
export * from "./Argument3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__